import { WizardStepStates } from "../wizard-step/wizard-step.options.js";
export const WizardPanelEventNames = {
    panelChange: "panel-change"
};
export const WizardPanelStates = { ...WizardStepStates };
//# sourceMappingURL=wizard-panel.options.js.map